import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["setPickButton"]

  connect() {
    this.locked = false
  }

  lock(event) {
    // Prevent multiple clicks
    if (this.locked) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }

    this.locked = true

    // disable the clicked button
    const element = event.currentTarget
    this.disableElement(element)
  }

  disableElement(element) {
    // Add disabled + loading state
    element.classList.add("disabled", "loading")
    element.setAttribute("aria-disabled", "true")
    element.style.pointerEvents = "none"
    element.style.opacity = "0.65"
  }
}